import {makeGlobalStore} from 'Common/Logical/GlobalStore.js';

export default class
{
    constructor() {
        this.events = {};
        this.store = makeGlobalStore();
    };

    $on(eventName, handler) {
        if (!this.events[eventName]) {
            this.events[eventName] = [];
        }
        this.events[eventName].push(handler);
    }

    $off(eventName, handler) {
        if (!this.events[eventName]) return;

        const index = this.events[eventName].indexOf(handler);
        if (index === -1) return;

        this.events[eventName].splice(index, 1);
    }

    $emit(eventName, ...args) {
        if (this.events[eventName]) {
            this.events[eventName].forEach((handler) => {
                handler(...args);
            });
        }
    }
}
